import React, { useEffect } from "react";
import Register from "./Register";
import Login from "./Login";
import { useSelector } from "react-redux";
import ForgotPassword from "../userForms/ForgotPassword";

function FormsModal(props) {
  const formToShow = useSelector((state) => state.form);

  return (
    <>
      <div
        className="modal fade"
        id="exampleModalCenter"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="d-flex align-items-center modal-content modal-content-form">
            {formToShow === "login" ? (
              <Login />
            ) : formToShow === "register" ? (
              <Register />
            ) : formToShow === "forgot_password" ? (
              <ForgotPassword />
            ) : (
              <Register />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default FormsModal;
